/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_KlassenInputs */

const nl_nav_klassen = /** @type {(inputs: Nav_KlassenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klassen`)
};

/**

* @param {Nav_KlassenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const nav_klassen = /** @type {((inputs?: Nav_KlassenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_KlassenInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_nav_klassen(inputs)
});
export { nav_klassen as "nav.klassen" }